<script setup lang="ts">
import { toast } from "vue3-toastify";
import type { ArticleSerie, Category } from "../articleTypes";
import { useArticleThemeStore } from "~/store/article/theme";

const { $privateApi } = useNuxtApp() as any;
const props = defineProps({
  theme: {
    type: Object as PropType<ArticleSerie | null>,
    required: true,
  },
  currentCategory: {
    type: Object as PropType<Category | null>,
    required: true,
  },
});

const isLoading = ref(false);
const bootstrap = (window as any).bootstrap;
let modal: any;

const articleThemeStore = useArticleThemeStore();

const deleteTheme = async () => {
  if (props.theme?._id) {
    try {
      if (props.currentCategory?._id) {
        isLoading.value = true;
        await $privateApi.delete(`/api/bo/article/series/${props.theme._id}`);
        await articleThemeStore.getThemesByCategory(props.currentCategory._id);
        if (
          articleThemeStore.selectedTheme !== "no-theme" &&
          articleThemeStore.selectedTheme?._id === props.theme._id
        ) {
          articleThemeStore.setSelectedTheme(null);
        }
        toast.success("Thème supprimé avec succès");
      }
    } catch (error: any) {
      toast.error(
        "Une erreur est survenue lors de la suppression du thème" +
          error.response.data.message
      );
    } finally {
      if (modal) {
        setTimeout(() => {
          modal.hide();
          isLoading.value = false;
        }, 1000);
      }
    }
  }
};

onMounted(() => {
  modal = new bootstrap.Modal("#delete_article_theme");
});
</script>
<template>
  <Teleport to="body">
    <div
      id="delete_article_theme"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
            <h6 class="mb-3">
              Êtes-vous sûr de vouloir supprimer le thème
              <span class="text-danger">{{ props.theme?.name }}</span> ?
            </h6>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-secondary me-2"
                data-bs-dismiss="modal"
              >
                Annuler
              </button>
              <button
                type="button"
                class="btn btn-danger"
                @click="deleteTheme"
                :disabled="isLoading"
              >
                <span v-if="isLoading">
                  <i class="bx bx-loader-circle bx-spin"></i>
                </span>
                <span v-else> Supprimer </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
